import React ,{useRef ,useEffect}from 'react';
import './currency-transfer.scss'
import IrtizaDynamicInputList from '../irtiza-dynamic-input/irtiza-dynamic-input-list';
import moment from 'moment'
import SecurityService from '../security/security.service';
import CurrencyTransferService from '../currency-transfer/currency-transfer.service';
import CurrencyTransferAdd from './currency-transfer-add';
import AuditTableInput from '../audit-table/audit-table'


const CurrencyTransferInput = (props) => {

useEffect(() => {
  
  console.log(SecurityService.getLoggedInShopID())
  return () => {
    
  };
}, []);

// MainCurrencyTransferID	
// CurrencyTransferID	
// CurrencyTransferDate	
// CurrencyNameFrom	
// CurrencyNameTo	
// AmountFrom	
// AmountTo	
// ExchangeRate	
// ShopName
    let columns =[
        {  field: "MainCurrencyTransferID",headerText:'ID',width:'90px',textAlign:'right' ,headerTextAlign:'center',other:[]},
        {  field: "CurrencyTransferID",headerText:'Currency Transfer ID',width:'140px',textAlign:'left' ,headerTextAlign:'center',other:[]},
        {  field: "CurrencyTransferDate",headerText:'Date',width:'100px',textAlign:'right' ,headerTextAlign:'center',other:[]},
        {  field: "ShopName",headerText:'Shop Name',width:'140px',textAlign:'left' ,headerTextAlign:'center',other:[]},
        {  field: "CurrencyNameFrom",headerText:'From Currency',width:'130px',textAlign:'left' ,headerTextAlign:'center',other:[]},
        {  field: "CurrencyNameTo",headerText:'To Currency',width:'120px',textAlign:'left' ,headerTextAlign:'center',other:[]},
        {  field: "AmountFrom",headerText:'From Amount',width:'130px',textAlign:'right' ,headerTextAlign:'center',other:[{'format':'n0'}]},
        {  field: "AmountTo",headerText:'To Amount',width:'130px',textAlign:'right' ,headerTextAlign:'center',other:[{'format':'n0'}]},
        {  field: "ExchangeRate",headerText:'Exchange Rate',width:'135px',textAlign:'right' ,headerTextAlign:'center',other:[{'format':'n2'}]}
       ]

       const listActionComplete = (grid,args ,getListService ,selectedRow )=>{
        console.log(args )
        console.log(getListService )
        console.log(selectedRow )
        if (args.requestType === 'beginEdit' || args.requestType === 'add') {
          }
        if (args.requestType == 'save' || args.requestType == 'cancel' ) {
          getListService()

        }

        if (args.requestType == 'save' && args.action == 'add') {
          console.log(args)
            CurrencyTransferService.insert({...args.data,ShopID:SecurityService.getLoggedInShopID(), CreatedByUserID:SecurityService.getLoggedInUserId()}).then((res)=>{
              console.log(res)
              
              getListService()
              let AddData = {
                CurrencyTransferID:args.data.CurrencyTransferID,
                CurrencyTransferDate:args.data.CurrencyTransferDate,
                ShopName:args.data.ShopName,
                CurrencyNameFrom:args.data.CurrencyNameFrom,  
                CurrencyNameTo:args.data.CurrencyNameTo,
                AmountFrom:args.data.AmountFrom,
                AmountTo:args.data.AmountTo,
                ExchangeRate:args.data.ExchangeRate 
              }
              AuditTableInput.auditAdd(`CurrencyTransfer`,`CurrencyTransfer`,`MainCurrencyTransferID`,AddData)
              })
          
        }
        if (args.requestType == 'save' && args.action == 'edit') {
          console.log(args)
            CurrencyTransferService.update({...args.data, UpdatedByUserID:SecurityService.getLoggedInUserId()}).then((res)=>{
              console.log(res)
              function convertToMozambiqueTime(dateString) {
                // Parse the date string with the GMT offset
                const gmtDate = moment(dateString, "ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
                
                // Convert the parsed date to Mozambique time zone (Africa/Maputo)
                const dateInMozambique = gmtDate.tz("Africa/Maputo").format('DD-MMM-YY');
                
                return dateInMozambique;
            }
              getListService()
              let EditData = {
                CurrencyTransferID:args.data.CurrencyTransferID,
                CurrencyTransferDate:convertToMozambiqueTime(args.data.CurrencyTransferDate),
                ShopName:args.data.ShopName,
                CurrencyNameFrom:args.data.CurrencyNameFrom,  
                CurrencyNameTo:args.data.CurrencyNameTo,
                AmountFrom:args.data.AmountFrom,
                AmountTo:args.data.AmountTo,
                ExchangeRate:args.data.ExchangeRate
              }
                        let totalColumns = Object.keys(EditData);
                        console.log(totalColumns)
                        AuditTableInput.auditEdit(totalColumns,selectedRow,EditData,`CurrencyTransfer`,args.data.MainCurrencyTransferID)
              })
          
        }
       }
       //   OPTIONAL PARAMETERS PLEASE DON'T PASS ANY TIME
    //    ***************************************************************************************************************
    //    ***************************************************************************************************************
    //    ***************************************************************************************************************
    //    ***************************************************************************************************************

        // Defines the  boolean
        // @default true
    let  allowTemplate = true
    let  allowGrouping = true
    let  allowExcelExport =true
    let  allowPdfExport = true
    let  showColumnChooser = true
    let  allowPaging = false
    let  allowDataBound = false
    let  allowGridSum = false

       
        // Defines the  string
        // @default CurrencyTransfer${typeMode} 
        let ListSecurity='CurrencyTransferList'
        let AddSecurity='CurrencyTransferAdd'
        let EditSecurity='CurrencyTransferEdit'
        let DeleteSecurity='CurrencyTransferDelete'
       
       // Defines the  ['Add','Edit','Delete','Update','Cancel','PDFExport','ExcelExport','Search','ColumnChooser'] | 'All'
       //  @default 'All'
      let toolbarOptions ='All';

      const toolbarClicking =  async (args)=>{
        console.log(args)
      }
      
       // Defines the 'Descending' | 'Ascending'
       //  @default 'Descending'
      let DefaultSortedColumnSort ='Descending';

       /* Defines the [{
                    TableName:'CurrencyTransfer' ,
                    TableID:'CurrencyTransferID',
                   // Optional if Delete is Soft // TableSecurity:'CurrencyTransferDelete',
                }]*/
    //  @default [] 
    //   let listDelete =  [{ TableName:'CurrencyTransfer' ,TableID:'CurrencyTransferID', Optional // TableSecurity:'CurrencyTransferDelete'}]
    let listDelete = [];
       
    // Defines 'Hard' | 'Soft' 
    // @Default 'Hard'
    let deleteType = 'Hard'


/* Defines the [   {field:'IsDeleted',
OPTIONAL HAI operator:'equal' or more check syncfusion documentation
        value:'No'},...more
        ] | []
      @default [] */
    //   let filterColumns = [{ field: 'IsDeleted', value: 'No' }];
      let filterColumns = [];

      /* Defines the [ColumnNames] | []
      @default [] */
    //   let groupColumns = ['IsDeleted','AccountTitleHawalaDr'];
      let groupColumns = [];

/* Defines the 'Dialog' | 'Normal'
      @default 'Dialog' */
      let gridEditSettingMode = 'Dialog';

/* Defines the '<p></p>' | Can give HTML | AND REACT FUNCTION LIKE HeaderTemplate
      @default '<p></p>' */
      let gridEditSettingHeaderTemplate = '<p></p>';

      /* Defines the  [ColumnNames] | []
      @default [] */
           //   let gridSumColumns = ['HawalaCommissionPercent'];
      let gridSumColumns = [];


    return (
        <IrtizaDynamicInputList
        Id='CurrencyTransfer'
        ListTitle='Currency Transfer  - List'
        ColumnsList={columns}
        GridDataSource= {[
                    {
                        DataSourceType: 'Function',
                        DataSource:  ()=> CurrencyTransferService.getCurrencyTransferForList(SecurityService.getLoggedInUserId() == 0 ? SecurityService.getLoggedInUserId() : SecurityService.getLoggedInShopID())
                        }]}
        DefaultSortedColumnName={'MainCurrencyTransferID'}
        GridDialog={[
            {
                DialogType:'Self',
                Dialog:<CurrencyTransferAdd ShopID={SecurityService.getLoggedInShopID()} />
                // Dialog:[
                //   {
                //     Title:'Invoice Evaluation',
                //     Inputs:[
                //       {field:{id:'MainInvoiceID',value:'InvoiceNo'},type:'dropdown',dataSource:{type:'Route',Route:'Invoice'},defaultValues:null},
                //       {field:{id:'CurrencyID',value:'CurrencyName'},type:'dropdown',dataSource:{type:'Route',Route:'CurrencyName'},defaultValues:null},
                //       {field:'ExchangeRate'	,type:'float',defaultValues:null},
                //       {field:'HawalaCommissionPercent'	,type:'float',defaultValues:null},
                //       {field:{id:'CurrencyIDHawala',value:'CurrencyNameHawala	'},type:'dropdown',dataSource:{type:'Route',Route:'CurrencyName'},defaultValues:null},
                //       {field:{id:'MainInvoiceID',value:'InvoiceNo'},type:'dropdown',dataSource:{type:'Route',Route:'Invoice'},defaultValues:null},
                //       {field:{id:'MainInvoiceID',value:'InvoiceNo'},type:'dropdown',dataSource:{type:'Route',Route:'Invoice'},defaultValues:null}
                //     ]
                //   }
                // ]

            }
        ]}
        ListActionComplete={listActionComplete}
        ToolbarClicking ={toolbarClicking}

        //   OPTIONAL PARAMETERS PLEASE DON'T PASS ANY TIME
            // AllowTemplate={allowTemplate}
            // ToolbarOption={toolbarOptions}
            // AllowGrouping={allowGrouping}
            // AllowExcelExport={allowExcelExport}
            // AllowPdfExport={allowPdfExport} 
            // ShowColumnChooser={showColumnChooser}
            // AllowPaging={allowPaging}
            // AllowDataBound={allowDataBound}
            // ListSecurity={ListSecurity}
            // AddSecurity={AddSecurity}
            // EditSecurity={EditSecurity}
            // DeleteSecurity={DeleteSecurity}
            // DefaultSortedColumnSort={DefaultSortedColumnSort}
            // FilterColumns={filterColumns} /* IT USED WHEN GIVING FILTER IN GRID LIKE IsDeleted Column or more */
            // GroupColumns={groupColumns} 
            // ListDelete={listDelete}
            // DeleteType={deleteType} 
            // GridEditSettingMode={gridEditSettingMode}
            // GridEditSettingHeaderTemplate={gridEditSettingHeaderTemplate}
            // GridSumColumns={gridSumColumns}
            // AllowGridSum={allowGridSum}
            {...props}
            ></IrtizaDynamicInputList>
            
            );
}



export default CurrencyTransferInput;
